export default __webpack_public_path__ + "static/media/ico_phone.6c93110d.svg";